import createHttpClient from '../library/create-http-client';
const httpClient = createHttpClient();
export default httpClient;